import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, Button } from 'components/common/Elements/Elements';

import classes from './AdditionalModal.module.scss';

const AdditionalModal = ({ isOpen = false, setIsOpen, info }) => {
  const modalRef = useRef();
  const [close, setClose] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    if (!close) {
      setClose(true);
      setOpen(false);
      setTimeout(function () {
        setIsOpen(false);
      }, 500);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const getFirstLast = () => {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button, textarea, input, select'
    );
    const focusableElements = Object.values(focusableModalElements).filter(
      elem => elem.disabled !== true
    );
    return {
      firstElement: focusableElements[0],
      lastElement: focusableElements[focusableElements.length - 1]
    };
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', escFunction);
      setClose(false);
      handleOpen();
    } else {
      document.removeEventListener('keydown', escFunction);
    }
    return () => {
      document.removeEventListener('keydown', escFunction);
    };
    // eslint-disable-next-line
  }, [isOpen]);

  const escFunction = e => {
    if (e.code === 'Escape') handleClose();
    if (e.shiftKey && e.keyCode === 9) {
      const elements = getFirstLast();
      if (document.activeElement === elements.firstElement) {
        elements.lastElement.focus();
        e.preventDefault();
      }
    }
    if (!e.shiftKey && e.keyCode === 9) {
      const elements = getFirstLast();
      if (document.activeElement === elements.lastElement) {
        elements.firstElement.focus();
        e.preventDefault();
      }
    }
  };

  const handleBg = e => {
    if (e.target.id === 'modal') {
      handleClose();
    }
  };

  return (
    <div
      className={cn(isOpen && classes.wrap)}
      id="modal"
      onClick={handleBg}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={cn(
          classes.box,
          open && classes.open,
          close && classes.close
        )}
        ref={modalRef}
      >
        {isOpen && (
          <>
            <Button
              className={classes.clear}
              onClick={() => handleClose()}
              title="close modal"
            >
              <Icon
                icon={'plus'}
                style={{
                  transform: `rotate(45deg)`
                }}
                className={classes.icon}
                size="24px"
              />
            </Button>
            {info.content}
          </>
        )}
      </div>
    </div>
  );
};

AdditionalModal.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
  info: PropTypes.object
};

export default AdditionalModal;
